import { render, staticRenderFns } from "./MoveList.vue?vue&type=template&id=e24d3018&scoped=true&"
import script from "./MoveList.vue?vue&type=script&lang=js&"
export * from "./MoveList.vue?vue&type=script&lang=js&"
import style0 from "./MoveList.vue?vue&type=style&index=0&id=e24d3018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24d3018",
  null
  
)

export default component.exports